import React,{Component} from "react";
import Cookies from "universal-cookie"
import "../scss/general.css";
import logo from "./images/loading.gif";
import logoerror from "./images/error.png";
import logosuccess from "./images/success.png";
import "../scss/radio.scss" ;
import Table from 'react-bootstrap/Table'
import Moment from "moment";
import Modal from "react-bootstrap/Modal"
import BusyModal from "./modalwait";

const axios = require("axios");
const ref = React.createRef();
const cookies=new Cookies();
const initialState={
    myitems:[],modalfooter:"",modalsize:"sm",isOpen:false,isLoaded:false,errorimg:"",modalTitle:"",errorprofile:"",errors:{},error:"",ErrMsg:<img src={logo} alt=""/>,errorcss:"labelerror",imagefile:config.Appdir+"/images/NoImage.png",FleetCard:""
}


class FuelReceiptEdit extends Component{
    constructor(props)
    {
        super(props);
            this.state=initialState;
            this.handledelete = this.handledelete.bind(this);
    }
    
    deleteConfirm(recid,i)
    {
        this.setState({ErrMsg2:"",isOpen:true,modalTitle:"Confirmation",modalsize:"sm",error:"Confirm to delete..",errorimg:logosuccess,modalfooter:<div><button onClick={() => {this.handledelete(recid,i)}}>Confirm</button><button onClick={this.hideModal}>Cancel</button></div>});
    }
    refresh(){}
    componentDidMount()
    {
        let id=cookies.get("LoginID");
        if(id.length > 1)
        {
            document.body.style.cursor="wait";
        }
        axios({
            method: 'post',
            url: cookies.get("phpclass")+'/index.php/userv/getfuelreceipt/'+id,
            headers: {'Content-Type': 'multipart/form-data'}
        })
        .then((response)=> {
//            console.log(response.data);
            document.body.style.cursor="default";        
            this.setState({isLoaded: true, myitems: response.data,ErrMsg:""});
        })
        .catch(()=> {
            //handle error
            this.setState({ErrMsg:""});
        }); 
    }
    showModal=()=>
    {
        this.setState({isOpen:true});
    }
    hideModal=()=>
    {
        document.body.style.cursor="default";
        this.setState({isOpen:false});
    }    
    handledelete(recid,i){
        document.body.style.cursor="wait";
        this.setState({isOpen:false,ErrMsg2:<BusyModal/>});        
         axios({
            method: 'post',
                url: cookies.get("phpclass")+'/index.php/userv/fueldelete/'+recid,
                headers: {'Content-Type': 'multipart/form-data'}
                })
                .then((response)=> {
                    document.body.style.cursor="default";
                    if(response.data ===1)
                    {   
                        this.state.myitems.splice(i,1);
                        this.setState({ErrMsg2:"",isOpen:true,modalsize:"sm",modalTitle:"Successfull", error:"Transaction has been deleted successfully...",errorimg:logosuccess,modalfooter:<button className="btn btn btn-success" onClick={this.hideModal}>Close</button>});
                    }
                    else
                    {
                        this.setState({ErrMsg2:"",isOpen:true,modalsize:"sm",modalTitle:"Error",error:'There might be a connection error. Please try later.',errorimg:logoerror,modalfooter:<button className="btn btn-danger" onClick={this.hideModal}>Close</button>});
                    }
                })
                .catch((response)=> {
                    document.body.style.cursor="default";
                    this.setState({ErrMsg2:"",isOpen:true,modalsize:"sm",modalTitle:"Unown error",error:response.error,errorimg:logoerror});
                }); 
        }
      render(){
        let isLoaded = this.state.isLoaded;
        let myItem = this.state.myitems;    
        if(!isLoaded) 
        {
            return (
                    <div className="center">
                          {this.state.ErrMsg}
                    </div>
            )
        } 
        else 
        {
        return(                        
            <div width="100%" align="left" scroll="hidden"   >
             <div className="inner-profile">
                <div className="form-group row">
                    <br></br>
                        <div style={{width:"100%",maxHeight:"400px" }}>
                            <Table striped bordered hover variant="dark">
                            <thead>
                                <tr>
                                    <th style={{width:"10%",padding:"5px 2px 5px 5px"}} >Vehicle#</th>
                                    <th style={{width:"12%",padding:"5px 2px 5px 5px"}}>Date</th>
                                    <th style={{width:"12%",padding:"5px 2px 5px 5px"}}>Mode</th>
                                    <th style={{width:"15%",padding:"5px 2px 5px 5px"}}>Type</th>
                                    <th style={{width:"22%",padding:"5px 2px 5px 5px"}}>Fleet Card#</th>

                                    <th style={{width:"10%",padding:"5px 2px 5px 5px",textAlign:"right"}}>Qty.</th>
                                    <th style={{width:"15%",padding:"5px 2px 5px 5px",textAlign:"right"}}>Amoumt</th>
                                    <th style={{width:"20%",padding:"5px 2px 5px 5px",textAlign:"right"}}>Reading</th>
                                    <th style={{width:"10%",padding:"5px 2px 5px 5px"}}></th>
                                </tr>
                            </thead>
                            <tbody>
                                {myItem.map((result, i)=>{
                                    return(
                                        <tr key={i} >
                                            <td style={{height:"10px",padding:"2px 2px 2px 5px"}}>{result.veh_reg_num}</td>
                                            <td style={{height:"12px",padding:"2px 2px 2px 5px"}}>{Moment(result.expens_date).format("DD/MM/YYYY")}</td>
                                            <td style={{height:"12px",padding:"2px 2px 2px 5px"}}>{result.payment_mode}</td>
                                            <td style={{height:"15px",padding:"2px 2px 2px 5px"}}>{result.fuel_type}</td>
                                            <td style={{height:"22px",padding:"2px 2px 2px 5px"}}>{result.fleet_card_num}</td>
                                            <td style={{height:"10px",padding:"2px 2px 2px 5px",textAlign:"right"}}>{result.fuel_qty}</td>
                                            <td style={{height:"15px",padding:"2px 2px 2px 5px",textAlign:"right"}}>{result.fuel_amt}</td>
                                            <td style={{height:"20px",padding:"2px 2px 2px 5px",textAlign:"right"}}>{result.veh_curr_mreading}</td>
                                            <td style={{height:"10px",padding:"2px 2px 2px 5px"}}><button onClick={() => {this.deleteConfirm(result.rec_id,i)}} value={i} className="fa fa-trash" ></button></td>
                                        </tr>
                                        );
                                    })}
                                </tbody>
                            </Table>
                        </div>
                    </div>            
                    </div>            

                    {this.state.ErrMsg}
                    <Modal show={this.state.isOpen} onHide={this.onhideModal} animation="false" centered backdrop="static" size={this.state.modalsize}>
                    <Modal.Header closeButton style={{backgroundColor:"gray", color:"white", height:"40px", paddingTop:2}}>
                    <Modal.Title>{this.state.modalTitle} </Modal.Title>
                    </Modal.Header>
                    <Modal.Body><img src={this.state.errorimg} style={{width:"30px",height:"30px"}}/><span style={{paddingLeft:"15px"}}>{this.state.error}</span><br/><br/>
                    <div style={{textAlign:"center"}}>{this.state.modalfooter}</div>
                    </Modal.Body>
                </Modal>
            </div>
      );}
    }}
export default FuelReceiptEdit;